import { LoginFormData } from '@pages/Login/Login.types';
import * as yup from 'yup';

yup.setLocale({
  mixed: {
    required: ({ path }) => `login.errors.${path}.required`,
  },
});

export const loginFormSchema = yup
  .object<Record<keyof LoginFormData, yup.AnySchema>>({
    emailAddress: yup
      .string()
      .email('login.errors.emailAddress.format')
      .required(),
    password: yup.string().required(),
    keepUserLoggedIn: yup.bool().required(),
  })
  .required();
